import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppLayoutComponent } from "./app.layout.component";
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { DialogModule } from 'primeng/dialog';
@NgModule({
    declarations: [AppLayoutComponent],
    imports: [
      CommonModule,
      RouterModule,
      SharedModule,
      DialogModule,

    ],
    exports: [AppLayoutComponent]
  })
  export class LayoutModule { }
